import { render, staticRenderFns } from "./WhatsappWidget.vue?vue&type=template&id=7bddd0c0&"
import script from "./WhatsappWidget.vue?vue&type=script&lang=js&"
export * from "./WhatsappWidget.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappWidget.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports